import { Button, MagellanPopup } from 'components/atoms';
import i18next from 'i18next';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiTrash, PiWarning } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { ISize } from 'types/components/components.interface';

interface IRemoveContractItemWIthChildrenPopupTriggerProps extends ISize {
  onClick?: () => void;
}

const RemoveContractItemWIthChildrenPopupTrigger = ({
  onClick,
  size,
}: IRemoveContractItemWIthChildrenPopupTriggerProps) => {
  return (
    <Button
      type='button'
      isClear
      size={size}
      fullWidth
      onClick={onClick}
      variant={BUTTON_VARIANT.remove}>
      <Button.Icon icon={<PiTrash />} />
      <Button.Text text={i18next.t('button.remove')} />
    </Button>
  );
};

interface IPopupRemoveContractItemWIthChildrenProps extends ISize {
  itemCount?: number;
  onRemove?: (actions: PopupActions | null) => void;
}

const RemoveContractItemWIthChildrenPopup = ({
  itemCount,
  onRemove,
  size,
}: IPopupRemoveContractItemWIthChildrenProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);

  return itemCount && itemCount > 1 ? (
    <Popup
      ref={popupRef}
      modal
      nested
      trigger={<RemoveContractItemWIthChildrenPopupTrigger size={size} />}>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiWarning />
          {t(`popup.header`)}
        </MagellanPopup.Header>
        <div className='flex flex-col opacity-55 max-w-96 text-center gap-4'>
          <p>
            <Trans
              i18nKey={'popup.remove-contract-item'}
              values={{ itemCount: itemCount }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p>{t(`popup.question`)}</p>
        </div>
        <div className='flex gap-2 mt-4'>
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t(`popup.cancel`)} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.remove}
            onClick={() => onRemove && onRemove(popupRef.current)}>
            <Button.Text text={t(`popup.approve`)} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  ) : (
    <RemoveContractItemWIthChildrenPopupTrigger
      onClick={() => onRemove && onRemove(popupRef.current)}
      size={size}
    />
  );
};

export default RemoveContractItemWIthChildrenPopup;
